export const asteriskFilter = string => {
  return string.replace(/(.{2})(.*)(?=@)/,
    function (gp1, gp2, gp3) {
      for (let i = 0; i < gp3.length; i++) {
        gp2 += "*";
      } return gp2;
    });
}